import React from "react";

type Props = {
  href: string;
  label: string;
};

/**
 * Botão “Saiba mais” do cabeçalho — um por tela, no `BreadCrumb.actions`.
 * Por quê: evita link de ajuda repetido dentro do tip (DOC 09 § 2.3).
 */
const PageHelpLink = ({ href, label }: Props) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className="btn btn-soft-secondary btn-sm"
  >
    {label}
    <i className="ri-external-link-line ms-1 align-middle" />
  </a>
);

export default PageHelpLink;
